<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconkaoguanchouqu"></i>
      考官管理
    </div>
    <div class="padding-sm">
      <div class="flex align-center justify-between margin-bottom-sm">
        <div class="flex align-center condition-warpper">
          <el-input
              v-model="name"
              placeholder="请输入姓名"
              class="margin-right-sm"
          ></el-input>
          <el-input
              v-model="phone"
              placeholder="请输入手机号"
              class="margin-right-sm"
          ></el-input>
          <el-select v-model="type" placeholder="请选择考官类型"  class="margin-right-sm">
            <el-option label="专业考官" value="1"></el-option>
            <el-option label="HR考官" value="2"></el-option>
          </el-select>
          <el-button type="primary" @click="onSearch">
            <p class="flex align-center font-size">
              <i class="el-icon-search margin-right-xs"></i>搜索
            </p>
          </el-button>
        </div>
        <el-button type="primary" @click="subdialogDialog = true">
          <p class="flex align-center font-size">
            <i class="iconfont iconxinzeng margin-right-xs"></i>添加考官
          </p>
        </el-button>
      </div>
      <div class="table-warpper">
        <el-table
            :data="examinerList"
            header-row-class-name="table-header"
            row-class-name="table-row"
            alig="center"
            fit
            style="width: 100%"
        >
          <el-table-column label="考官编号">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.number }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.name }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="类型">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.type === 1 ? '专业考官' : 'HR考官' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="联系电话">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.phone }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="参与场次">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.num }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div class="table-operate">
                <el-button
                    size="medium"
                    type="primary"
                    @click="editItem(scope.row)"
                >编辑
                </el-button>
                <el-button
                    size="medium"
                    type="danger"
                    @click="deleteItem(scope.row.id)"
                >删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            v-if="examinerList.length > 0"
            class="page-all"
            background
            @current-change="setPage"
            :current-page.sync="page"
            :page-size="limit"
            layout="prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <subdialog-dialog
        :setId="setId"
        :setItem="setItem"
        :subdialogDialog="subdialogDialog"
        @cancelDialog="cancelDialog"
    />
  </div>
</template>

<script>
import {examinerList, examinerDel} from "@/api/projectOffice";
import subdialogDialog from "@/views/projectOffice/page/dialog/examinerDialog";

export default {
  name: "examiner",
  data() {
    return {
      name: '',
      phone: '',
      type: '',
      page: 1,
      total: 0,
      limit: 10,
      examinerList:[],
      setId: 0,
      setItem: {},
      subdialogDialog: false
    };
  },
  components: {
    subdialogDialog
  },

  created() {
    this.$emit(
        "setIndex",
        this.$route.path,
        "当前位置：考官管理",
        false
    );
    this.getList();
  },
  methods: {
    async getList() {
      let _list = await examinerList(
          this.name,
          this.phone,
          this.type,
          this.page,
          this.limit
      );
      this.examinerList = _list.data.list;
      this.total = _list.data.count;
    },
    setPage() {
      this.getList();
    },
    editItem(obj) {
      this.setItem = obj;
      this.setId = obj.id;
      this.subdialogDialog = true;
    },
    deleteItem(id) {
      this.$confirm("确定要删除该考官吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      console.log(id)
      let _state = await examinerDel(id);
      if (this.examinerList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getList();
      this.$message.success(_state.msg);
    },
    cancelDialog(val) {
      if (val) {
        this.setId = 0;
        this.setItem = {};
        this.subdialogDialog = false;
        if (this.setId) {
          this.getList();
        } else {
          this.page = 1;
          this.getList();
        }
      } else {
        this.setId = 0;
        this.setItem = {};
        this.subdialogDialog = false;
      }
    },
    onSearch() {
      this.page = 1;
      this.getList();
    },
  }
}
</script>

<style scoped lang="scss">

</style>